import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const fetchCandidatesLocations = (): Promise<any> => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/clinics/candidates_location_filters`,
  });
};

export default fetchCandidatesLocations;
